import nookies from 'nookies';
const GUEST_COOKIE_NAME = 'bl-guest';
const getGuestCookie = (ctx) => nookies.get(ctx)[GUEST_COOKIE_NAME];
export const isGuest = (ctx) => getGuestCookie(ctx) === 'true';
